import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { DateLabel, Ticket, Wrapper } from './styles'
//import Price from 'components/shared/Price'
import suntagoLogo from 'assets/images/logos/Suntago.svg'
import Link from 'components/shared/Link'
import SeparatedList from 'components/shared/SeparatedList'
import { useState } from 'react'
import { useResolutions } from 'store/resolutions'
import CabanaRow from './ticketRows/Cabana'
import TicketsRow from './ticketRows/Tickets'
import TransportRow from './ticketRows/Transport'
//import MemoryCaptureRow from './ticketRows/MemoryCapture'
import { SelfcareAccomodation } from 'components/global/SelfcareAccomodation'
import { getDayNameAndDate } from 'helpers/dates'
import { sortDates } from 'helpers/helpers'
import { FormattedMessage } from 'react-intl'
import { SELFCARE_STEPS } from 'routes/steps'
import { useAppSelector } from 'store/hooks'
import { useApp } from 'store/steps'
import { FamilyPackageRow } from './FamilyPackageRow'
import SpaRow from './ticketRows/SpaRow'
import UpgradeAttractionRow from './upgradeYourStay/UpgradeAttractionRow'
const Reservation = () => {
    const { navigateToStep } = useApp()
    const { hasAccommodation } = useAppSelector((state) => state.selfcare)
    const [areDetailsVisible, setAreDetailsVisible] = useState(true)
    const { isTablet } = useResolutions()
    const {
        tickets,
        cabanas,
        spa,
        memoryCapture,
        transport,
        orderId,
        isRevertLoading,
        ticketsBundles,
    } = useAppSelector((state) => state.selfcare)
    const isFamilyPackage = ticketsBundles && ticketsBundles.length > 0

    const ticketDates =
        tickets &&
        sortDates(
            Array.from(
                new Set(tickets.map((ticket) => ticket.original.detail.day))
            )
        )

    const toggleDetails = () => setAreDetailsVisible(!areDetailsVisible)

    const areAllUpsellsInOrder =
        !!transport?.length && !!cabanas?.length && !!memoryCapture?.length

    const ticketActions = (
        <Box
            direction="row"
            align="center"
            justify="center"
            gap={36}
            mb={[0, 8]}
        >
            <Link
                variant="secondary"
                icon="chevron"
                iconRotation={areDetailsVisible ? 180 : 0}
                onClick={toggleDetails}
                data-testid={`selfcare-reservation-trigger-${
                    areDetailsVisible ? 'hide' : 'show'
                }-details`}
            >
                {areDetailsVisible ? (
                    <FormattedMessage
                        id="global.btn.collapse_details"
                        defaultMessage="Zwiń szczegóły"
                    />
                ) : (
                    <FormattedMessage
                        id="global.btn.extend_details"
                        defaultMessage="Pokaż szczegóły"
                    />
                )}
            </Link>
            <Link
                variant="primary"
                onClick={() =>
                    !isRevertLoading &&
                    navigateToStep({ stepId: SELFCARE_STEPS[1].id })
                }
                data-testid="selfcare-reservation-button-manage"
            >
                <FormattedMessage
                    id="selfcare.starter.reservation_manage"
                    defaultMessage="Zarządzaj"
                />
            </Link>
        </Box>
    )

    return (
        <Wrapper mr={[0, 20]} areDetailsVisible={areDetailsVisible}>
            <Ticket
                pt={[4, 16]}
                pb={[24, 16]}
                pl={[16, 30]}
                pr={[16, 64]}
                direction={['column', 'row']}
                isFullWidth
            >
                <SeparatedList
                    direction="column"
                    gap={24}
                    borderWidth={2}
                    isFullWidth
                    borderColor="grayscale_300"
                >
                    <SeparatedList
                        gap={[4, 40]}
                        direction={['column', 'row']}
                        borderWidth={[0, 1]}
                        isFullWidth
                        borderColor="grayscale_300"
                    >
                        <Box
                            justify="center"
                            align={['center', 'flex-start']}
                            hasNoShrink
                        >
                            <img
                                src={suntagoLogo}
                                alt="Suntago logo"
                                width="120"
                                height="120"
                            />
                        </Box>
                        <Box isFullWidth align={['center', 'flex-start']}>
                            {ticketDates?.[0] && (
                                <DateLabel
                                    mt={[0, 8]}
                                    mb={24}
                                    pl={16}
                                    pr={16}
                                    pt={4}
                                    pb={4}
                                >
                                    <Text
                                        variant="bodyExtraSmall"
                                        color="secondary_500"
                                    >
                                        {getDayNameAndDate({
                                            date: ticketDates[0],
                                            isShortDayName: false,
                                        })}
                                        {ticketDates.length > 1 &&
                                            ` - ${getDayNameAndDate({
                                                date: ticketDates[
                                                    ticketDates.length - 1
                                                ],
                                                isShortDayName: false,
                                            })}`}
                                    </Text>
                                </DateLabel>
                            )}
                            <Text
                                variant="heading3"
                                color="grayscale_900"
                                mb={8}
                            >
                                <FormattedMessage
                                    id="global.attractions.caption_suntago"
                                    defaultMessage="Suntago Wodny Świat"
                                />
                            </Text>
                            <Text
                                variant="bodyExtraSmall"
                                color="grayscale_700"
                                mb={[16, 30]}
                            >
                                {orderId}
                            </Text>
                            {!isTablet && ticketActions}
                        </Box>
                        {/* <Box justify="center" align={['center', 'flex-start']}>
                            <Price value={16400} size="heading2" />
                        </Box> */}
                    </SeparatedList>

                    {isTablet && ticketActions}
                </SeparatedList>
            </Ticket>

            {areDetailsVisible && (
                <Box
                    isFullWidth
                    pt={[24, 32]}
                    pl={[16, 64]}
                    pr={[16, 64]}
                    pb={[24, 40]}
                    gap={[24, 40]}
                >
                    {isFamilyPackage && (
                        <FamilyPackageRow isDownloadingAttachementsDisabled />
                    )}
                    {tickets && tickets.length > 0 && (
                        <TicketsRow
                            mode="reservation"
                            tickets={tickets}
                            isDownloadingAttachementsDisabled
                        />
                    )}
                    {spa && spa.length > 0 && (
                        <SpaRow
                            mode="reservation"
                            spa={spa}
                            isDownloadingAttachementsDisabled
                        />
                    )}
                    {transport && transport.length > 0 && (
                        <TransportRow
                            mode="reservation"
                            transport={transport}
                            isDownloadingAttachementsDisabled
                        />
                    )}
                    {cabanas && cabanas.length > 0 && (
                        <CabanaRow
                            mode="reservation"
                            cabanas={cabanas}
                            isDownloadingAttachementsDisabled
                        />
                    )}
                    {hasAccommodation && <SelfcareAccomodation />}
                    {/*TODO: module disabled: MEMORY CAPTURE */}
                    {/*{memoryCapture && memoryCapture.length > 0 && (
                        <MemoryCaptureRow
                            mode="reservation"
                            tickets={memoryCapture}
                        />
                    )}*/}
                    {!areAllUpsellsInOrder && <UpgradeAttractionRow />}
                </Box>
            )}
        </Wrapper>
    )
}

export default Reservation
